import { useLocation } from '@tanstack/react-router';
import { type RefObject, useEffect } from 'react';

/**
 * Scrolls `ref` back to the top when the path changes. For layouts that scroll their own
 * container rather than the window, so a new page doesn't inherit the previous one's position.
 */
export function useScrollTopOnNavigate(ref: RefObject<HTMLElement | null>): void {
  const { pathname } = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: pathname is only the trigger
  useEffect(() => {
    ref.current?.scrollTo({ top: 0 });
  }, [ref, pathname]);
}
